"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newWordCloudPin = void 0;
const lodash_1 = require("lodash");
const newWordCloudPin = (layoutTemplate) => {
    const basePin = {
        type: 'WORD_CLOUD',
        settings: {
            layout: layoutTemplate.key,
            backgroundColor: layoutTemplate.backgroundColor,
            backgroundImage: layoutTemplate.backgroundImage,
            questionId: layoutTemplate.layoutParts.TITLE?.id,
            layoutParts: (0, lodash_1.mapValues)(layoutTemplate.layoutParts, (comp) => comp?.id),
        },
        teacherSettings: {},
        pinComponents: [...Object.values(layoutTemplate.layoutParts), ...layoutTemplate.pinComponents],
    };
    if ('backgroundTransparency' in layoutTemplate && layoutTemplate.backgroundTransparency !== undefined) {
        basePin.settings.backgroundTransparency = layoutTemplate.backgroundTransparency;
    }
    return basePin;
};
exports.newWordCloudPin = newWordCloudPin;
//# sourceMappingURL=word-cloud-pin.js.map